import React from "react";

function Services() {
  const services = [
    {
      id: 1,
      icon: "🚚",
      name: "Fast Delivery",
      description: "Same-day and next-day delivery available in Lahore"
    },
    {
      id: 2,
      icon: "💳",
      name: "Flexible Payment",
      description: "Multiple payment options including cards, cash on delivery, and installments"
    },
    {
      id: 3,
      icon: "🛡️",
      name: "Warranty Support",
      description: "Full manufacturer warranty on all products with authorized service centers"
    },
    {
      id: 4,
      icon: "📞",
      name: "Customer Support",
      description: "24/7 customer service team ready to help with any queries"
    },
    {
      id: 5,
      icon: "🔄",
      name: "Easy Returns",
      description: "30-day return policy for hassle-free shopping experience"
    },
    {
      id: 6,
      icon: "✅",
      name: "Price Guarantee",
      description: "Best price guarantee - we match or beat any competitor's price"
    }
  ];

  return (
    <div className="services-page">
      <div className="page-header">
        <h1>Our Services</h1>
        <p>We go beyond just selling products - we provide complete solutions</p>
      </div>

      <div className="container">
        <section className="services-intro">
          <p>
            At Samsung Door-Step, we're committed to providing exceptional service that goes beyond 
            just product delivery. Our comprehensive service offerings are designed to make your shopping 
            experience smooth, secure, and satisfying.
          </p>
        </section>

        <section className="services-grid">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.name}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </section>

        <section className="delivery-zones">
          <h2>Delivery Coverage</h2>
          <div className="cities-grid">
            <div className="city">Lahore</div>
            {/* Other cities - commented for future expansion
            <div className="city">Karachi</div>
            <div className="city">Islamabad</div>
            <div className="city">Rawalpindi</div>
            <div className="city">Multan</div>
            <div className="city">Faisalabad</div>
            <div className="city">Peshawar</div>
            <div className="city">Quetta</div>
            <div className="city">Hyderabad</div>
            <div className="city">Sukkur</div>
            <div className="city">Sialkot</div>
            <div className="city">Gujranwala</div>
            */}
          </div>
          <p className="note">*Doorstep delivery available in Lahore. Free shipping on orders above PKR 5,000</p>
        </section>

        <section className="faq-section">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-items">
            <div className="faq-item">
              <h4>How long does delivery take?</h4>
              <p>Same-day delivery is available in Lahore. We deliver within 24 hours in most areas.</p>
            </div>
            <div className="faq-item">
              <h4>What payment methods do you accept?</h4>
              <p>We accept credit/debit cards, bank transfers, cash on delivery, and JazzCash/EasyPaisa payments.</p>
            </div>
            <div className="faq-item">
              <h4>Can I return a product?</h4>
              <p>Yes, we offer a 30-day return policy. Products must be unused and in original packaging.</p>
            </div>
            <div className="faq-item">
              <h4>Are your products authentic?</h4>
              <p>Yes, 100% authentic. All products are directly from Samsung with complete warranty coverage.</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Services;
